export default __webpack_public_path__ + "static/media/SHDP-1080x1080-final.bdfdb833.png";